module.exports = __webpack_public_path__ + "static/media/qrcode_bg2.5f0e250a.png";